import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../core/services';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import { untilDestroyed } from 'ngx-take-until-destroy';
import {validateAllFormFields} from '../../shared/utils/form.utils';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  error: string;
  private submitting = false;

  constructor(
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    public router: Router,
    private fb: FormBuilder) {

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: false
    });
  }

  ngOnInit() {
    this.error = '';
    this.loginForm.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.error = '';
    });
  }

  ngOnDestroy(): void {
    this.error = '';
  }

  login() {
    if (this.loginForm.invalid) {
      validateAllFormFields(this.loginForm);
      return;
    }
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    const emailControl = this.loginForm.get('email');
    emailControl.setValue(emailControl.value.toLowerCase(), {emitEvent: false});
    this.spinner.show('auth');
    this.authService.login(this.loginForm.value).subscribe(() => {
      this.submitting = false;
      this.spinner.hide('auth');
      if (!this.authService.isLoggedIn) {
        this.error = 'שם המשתמש או הסיסמא אינם נכונים';
        return;
      }
      try {
        if (window['dataLayer'] && typeof window['dataLayer'].push === 'function') {
          window['dataLayer'].push({
            event: 'login',
            eventCategory: 'login',
            eventAction: 'success',
          });
        }
      } catch (e) {
        // analytics must not block login redirect
      }
      const redirect = this.authService.redirectUrl ? this.router.parseUrl(this.authService.redirectUrl) : '/';
      this.router.navigateByUrl(redirect);
    }, () => {
      this.submitting = false;
      this.spinner.hide('auth');
      this.error = 'שם המשתמש או הסיסמא אינם נכונים';
    });
  }

}
